import * as pdfjsLib from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Shared pdf.js setup for the field designer (admin) and the signer overlay.
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

export async function loadPdf(url: string) {
  return pdfjsLib.getDocument({ url, withCredentials: true }).promise;
}

export type LoadedPdf = Awaited<ReturnType<typeof loadPdf>>;

// Renders a page into the given canvas at a fixed display width and returns the
// resulting pixel size (used to lay the field overlay on top).
export async function renderPageToCanvas(
  pdf: LoadedPdf,
  pageNumber: number,
  canvas: HTMLCanvasElement,
  displayWidth: number,
): Promise<{ width: number; height: number }> {
  const page = await pdf.getPage(pageNumber);
  const base = page.getViewport({ scale: 1 });
  const scale = displayWidth / base.width;
  const viewport = page.getViewport({ scale });
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D unavailable');
  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  canvas.style.width = `${Math.floor(viewport.width)}px`;
  canvas.style.height = `${Math.floor(viewport.height)}px`;
  await page.render({ canvasContext: ctx, viewport }).promise;
  return { width: canvas.width, height: canvas.height };
}
